export default __webpack_public_path__ + "static/media/banner_post_page2.a12f9ed4.png";